export const OFFERS = "offers";
export const CATEGORIES = `${OFFERS}/categories`;
export const UPCOMING = `${OFFERS}/upcoming`;
export const PAST = `${OFFERS}/past`;
export const SIMILAR = `${OFFERS}/similar`;
export const PAGES = "pages";
export const THEMES = "themes";
export const INDICATORS = "indicators";
